var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitsNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    style: {
      mixBlendMode: "saturation"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2392 8.502C11.7276 9.5676 12 10.752 12 12C12 13.248 11.7276 14.4324 11.2392 15.498C14.5248 15.0804 16.8 13.458 16.8 12C16.8 10.542 14.5248 8.9196 11.2392 8.502ZM18 9.0924C19.2624 7.6716 21.4212 6.6036 24 6.1884V17.8104C21.4212 17.3964 19.2624 16.3284 18 14.9064C16.362 16.752 13.2144 18 9.6 18C4.2984 18 0 15.3132 0 12C0 8.6868 4.2984 6 9.6 6C13.2144 6 16.362 7.248 18 9.0924ZM21.6 14.4V9.6C20.22 9.876 19.2 10.8456 19.2 12C19.2 13.1544 20.22 14.124 21.6 14.4ZM2.4 12C2.4 13.524 4.8924 15.2352 8.4384 15.5496C9.19542 14.5212 9.60256 13.277 9.6 12C9.60256 10.723 9.19542 9.47884 8.4384 8.4504C4.8924 8.7648 2.4 10.476 2.4 12ZM6 13.2C5.68174 13.2 5.37652 13.0736 5.15147 12.8485C4.92643 12.6235 4.8 12.3183 4.8 12C4.8 11.6817 4.92643 11.3765 5.15147 11.1515C5.37652 10.9264 5.68174 10.8 6 10.8C6.31826 10.8 6.62348 10.9264 6.84853 11.1515C7.07357 11.3765 7.2 11.6817 7.2 12C7.2 12.3183 7.07357 12.6235 6.84853 12.8485C6.62348 13.0736 6.31826 13.2 6 13.2Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitsNav);
export default __webpack_public_path__ + "static/media/benefits-nav.ae197df0ef50548223eee10a0ff30ec8.svg";
export { ForwardRef as ReactComponent };